import { ErrorSlots } from '../../constants';
import { Helper } from '../Helper';
export class ThrowHelper extends Helper {
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitOp(node, 'DUP');
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'DUP');
                sb.emitHelper(node, options, sb.helpers.isString);
            },
            whenFalse: () => {
                sb.emitHelper(node, options, sb.helpers.unwrapError);
                sb.emitPushInt(node, ErrorSlots.message);
                sb.emitOp(node, 'PICKITEM');
            },
        }));
        sb.emitHelper(node, options, sb.helpers.unwrapString);
        sb.emitLine(node);
        sb.emitOp(node, 'SWAP');
        sb.emitPushString(node, 'error');
        sb.emitPushInt(node, 3);
        sb.emitOp(node, 'PACK');
        sb.emitSysCall(node, 'Neo.Runtime.Notify');
        sb.emitHelper(node, optionsIn, sb.helpers.throwCompletion);
    }
}

//# sourceMappingURL=ThrowHelper.js.map
